window.PlummeI18n.register('no', {
  'adv.cost.review': 'Se nærmere',
  'adv.cost.moreTitle': 'Flere muligheter',
  'adv.cost.observedValue': 'Observert verdi',
  'adv.cost.invoiceBasis': 'Fakturagrunnlag',
  'adv.cost.draftValue': 'Utkastverdi',
  'adv.cost.possibleCount': 'Mulige duplikater',
  'adv.cost.purchaseShare': 'Innkjøpsandel',
  'adv.cost.givenDiscount': 'Gitt rabatt',
  'adv.cost.unbilledNote': 'Fakturagrunnlag, ikke bokført inntekt',
  'adv.cost.draftNote': 'Utkastverdi, ikke bokført inntekt',
  'adv.cost.acceptedNote': 'Aksepterte tilbud uten tilknyttet faktura',
  'adv.cost.duplicateNote': 'Mulige duplikater som må kontrolleres',
  'adv.cost.supplierNote': 'Innkjøpsvolum som kan gi grunnlag for forhandling',
  'adv.cost.discountTitle': 'Gå gjennom rabattene som er gitt',
  'adv.cost.discountNote': 'Faktisk gitt rabatt, ikke beregnet besparelse',
  'adv.cost.voucherNote': 'Dokumentasjon som må følges opp; ingen beregnet besparelse',
  'adv.cost.followUp': 'Til oppfølging',
  'adv.cost.increaseToReview': 'Økning å undersøke',
  'adv.cost.fixedTitle': 'Bokførte faste kostnader',
  'adv.cost.tryAdjustment': 'Prøv en justering',
  'adv.cost.fixedDetail': 'Snitt per måned, basert på {months} hele måneder',
  'adv.cost.otherTitle': 'Største øvrige kostnadskontoer',
  'adv.cost.otherIntro': 'Andelen viser bokført kostnad mot omsetning i valgt år. Den er ikke et spareanslag, og kontoen klassifiseres ikke automatisk som variabel.',
  'adv.cost.otherDetail': '{amount} bokført i valgt år',
  'adv.cost.ofRevenue': 'av omsetningen',
  'adv.cost.noRevenueShare': 'Andel ikke beregnet',
  'adv.cost.sub': 'Største bokførte kostnadskontoer og endring mot fjoråret',
  'adv.cost.subPeriod': 'Største bokførte kostnadskontoer og endring mot samme periode i fjor',
  'adv.cost.help': 'Kontoene kommer fra resultatrapporten for valgt år. Søylene viser bokført beløp per konto. Endring vises bare når samme konto har et positivt beløp i fjoråret.',
  'adv.cost.helpPeriod': 'Kontoene kommer fra resultatrapporten til og med inneværende måned. Søylene viser bokført beløp per konto. Endring sammenlignes med samme periode i fjor når kontoen hadde et positivt beløp.',
  'adv.cost.rowHelp': 'Bokført på kontoen: {amount} i valgt år. Endring mot fjoråret: {change}.',
  'adv.cost.noComparison': 'Ingen fjorårstall',
  'adv.cost.emptyText': 'Ingen bokførte kostnadskontoer i valgt år.',
  'adv.cost.flagText': '{name} har økt betydelig mot fjoråret. Kontroller om endringen er planlagt og gjennomgå posteringene på kontoen.',
  'adv.why.costSub': 'Kostnadskontoer som har økt betydelig mot fjoråret',
});
